import { render } from "./Auth.vue?vue&type=template&id=7920d7f2&scoped=true&ts=true"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"

import "./Auth.vue?vue&type=style&index=0&id=7920d7f2&lang=scss&scoped=true"

import exportComponent from "/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7920d7f2"]])

export default __exports__